import { Alert, Badge, Card, Spin, Typography } from 'antd';
import React, { useState } from 'react';
import moment from 'moment';
import { handleApiExceptions } from '../../../app_methods';
import { Text4 } from '../../../styles';
import { PAYMENT_STATUSTYPES } from './constants';
import { EaseDrawer } from '../../../libs/EaseDrawer';

const PaymentAttemptsDrawer = (props) => {
    const direct_tax = props.direct_tax || {};
    const [attempts, setAttempts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchPaymentAttempts = async () => {
        setIsLoading(true);
        const response = await direct_tax.fetchPaymentAttempts();
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        setAttempts(response.data.attempts);
        setIsLoading(false);
    };

    const renderCardTitle = (attempt) => {
        return (
            <div className="mb-2 d-flex justify-content-between">
                <div>
                    <Badge
                        size="large"
                        color={attempt ? attempt.status ? PAYMENT_STATUSTYPES[attempt.status].color : 'green' : ''}
                        text={<Text4 strong>{attempt ? attempt.status ? PAYMENT_STATUSTYPES[attempt.status].label : 'Success' : '---'}</Text4>}
                    />
                </div>
                <div className="d-flex align-items-center justify-content-end">
                    <Text4 type="secondary">{attempt.created_at && moment(attempt.created_at).format("LLL")}</Text4>
                </div>
            </div>
        )
    };

    const renderCardDetails = (attempt) => {
        return (
            <>
                <div className="row">
                    <div className="col-6">
                        <Text4 type="secondary" strong>Attempt By:</Text4>
                    </div>
                    <div className="col-6">
                        <Text4>{attempt.payment_initiated_by ? attempt.payment_initiated_by.name : '---'}</Text4>
                    </div>
                </div>

                <div className="row">
                    <div className="col-6">
                        <Text4 type="secondary" strong>Source Account:</Text4>
                    </div>
                    <div className="col-6">
                        <Text4>{attempt.source_account.funding_via == 1 ? attempt.source_account.virtual_account_number : "Credit Card Account"}</Text4>
                    </div>
                </div>
            </>
        )
    }

    return (
        <EaseDrawer
            className="payment-attempts-drawer-wrapper"
            visible={props.visible}
            onOpen={fetchPaymentAttempts}
            onClose={props.onClose}
            hideHeader
            hideFooter
            width={500}
        >
            <Typography.Title className="mt-4 mb-4" level={4}>Payment Attempts</Typography.Title>
            {
                isLoading ?
                    <div style={{ width: "100%", height: "84vh" }} className="d-flex justify-content-center align-items-center">
                        <Spin className="mt-4" tip="Loading..." spinning={isLoading} />
                    </div>
                    :
                    attempts.length ?
                        attempts.map((attempt, index) => {
                            return (
                                <Card
                                    className="mb-2"
                                    size="small"
                                    title={false}
                                >
                                    {renderCardTitle(attempt)}
                                    {renderCardDetails(attempt)}
                                </Card>
                            );
                        })
                        :
                        <Alert
                            message="Nothing to show"
                            description="No payment attempts have been made so far."
                            type="info"
                            showIcon
                        />
            }
        </EaseDrawer>
    )
};

export { PaymentAttemptsDrawer };